import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import Loading from "../../../Shared/components/loading";
import { PaymentForm } from "../../../Shared/components/PaymentForm/PaymentForm";
import { AnimatedSuccessCheckmark } from "../AnimatedSuccessCheckmark";
import { SuccessStatusText } from "./PaymentDialog-types";
/**
 * This component renders the appropriate content for the payment dialog
 * based on the loading state, error state, payment completion, and remaining balance.
 *
 * @param {string} [props.loading] - Indicates if the payment process is currently loading.
 *                                   If truthy, a loading indicator is shown.
 * @param {string} [props.error] - An error message to display if an error occurs.
 *                                 If truthy, an error message is shown.
 * @param {boolean} [props.paymentComplete] - Flag indicating whether the payment has been completed.
 *                                            If true, a success checkmark is displayed.
 * @param {number} [props.remainingBalance] - The remaining balance of the order.
 *                                            Used to display appropriate text.
 *
 * @returns {JSX.Element} The appropriate content based on the current state:
 *                        - A loading spinner if loading is in progress.
 *                        - An error message if an error occurred.
 *                        - A success indicator if the payment is complete.
 *                        - The payment form if none of the above conditions are met.
 */
export const PaymentDialogContent = ({ loading, error, paymentComplete, remainingBalance, }) => {
    if (loading)
        return _jsx(Loading, { text: loading });
    if (error)
        return _jsx(Loading, { error: true, text: `Error! ${error}` });
    if (paymentComplete)
        return _jsx(SuccessCheckmark, { remainingBalance: remainingBalance });
    return _jsx(PaymentForm, {});
};
export const SuccessCheckmark = ({ remainingBalance }) => {
    return (_jsxs(Stack, Object.assign({ justifyContent: "center", alignItems: "center" }, { children: [_jsx(AnimatedSuccessCheckmark, {}), _jsx(Typography, Object.assign({ color: "success" }, { children: remainingBalance === 0 ? SuccessStatusText.CHANGES_SAVED : SuccessStatusText.PAYMENT_COMPLETE }))] })));
};
